import { useState } from 'react';

import useStateHandler from '@/hooks/useStateHandler';
import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';

import ShippingNameInput from '../../components/ShippingNameInput';

import './styles/UpdateShippingItem.css';

export default function UpdateShippingItem({ data, close, onUpdateShippingData }) {
  const t = useTranslations('common.forms.add_artwork');
  const [newName, setNewName] = useState(data.saved_shipping_name);
  const { stateHandler } = useStateHandler();

  const handleSaveChanges = () => {
    onUpdateShippingData({
      ...data,
      saved_shipping_name: newName
    });
    stateHandler.set("temporalPopup", { 
      text: t('shipping.updated_successfully'),
    });
    close();
  };

  return (
    <>
      <div className="update-shipping-item__header">
        <Text className="update-shipping-item__header-text">
          {t('shipping.rename_information')}
        </Text>
        <XIcon className="update-shipping-item__close" onClick={close}/> 
      </div>

      <ShippingNameInput
        className="shipping-name-input--update"
        value={newName} 
        onChange={event => setNewName(event.target.value)}
        placeholder={t('shipping.update_name_placeholder')}
      />

      <ContinueButton 
        turnOff={newName === ""}
        onClick={handleSaveChanges}
      >
        {t('shipping.save_changes')}
      </ContinueButton>
    </>
  );
}
